<template>
  <v-card :loading="loading" flat>
    <v-card-text>
      <v-container>
        <listing-form :data="data"></listing-form>
      </v-container>
    </v-card-text>
    <v-card-actions>
      <v-btn color="primary" @click="_changeModel(4)">
        <v-icon>mdi-chevron-left</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn color="primary" @click="_changeModel(1)">
        Finish
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import ListingForm from './ListingForm'
import { axios } from '../../../../utils'
import { mapGetters } from 'vuex'
export default {
  props: ['changeModel', 'client_id', 'index'],
  components: {
    ListingForm
  },
  data() {
    return {
      loading: false,
      data: {
        id: null,
        about: '',
        description: '',
        productsServices: '',
        keywords: [],
        special: '',
        latitude: 0,
        longitude: 0,
        links: {
          facebook: '',
          instagram: '',
          youtube: ''
        },
        offer: '',
        file: null,
        image: null,
        fileLoading: false
      }
    }
  },

  mounted() {
    console.log('listing index mounted')
  },

  computed: {
    ...mapGetters(['permissions/getModelPermissions']),
    modelPermissions() {
      return this['permissions/getModelPermissions']('listing')
    }
  },
  methods: {
    _changeModel(index) {
      if (this.data.id !== null) {
        this.update(index)
      } else {
        this.create(index)
      }
    },
    create(index) {
      if (this.modelPermissions.create) {
        console.log('listing create')
        axios
          .post('api/admin/listings/create', {
            client_id: this.client_id,
            about: this.data.about,
            description: this.data.description,
            productsServices: this.data.productsServices,
            latitude: this.data.latitude,
            longitude: this.data.longitude,
            special: this.data.special,
            links: JSON.stringify(this.data.links),
            offer: this.data.offer,
            keywords: this.data.keywords
          })
          .then(res => {
            this.clearData()
            console.log(res)
            this.data.id = res.data.id
            this.changeModel(index)
          })
      } else {
        this.changeModel(index)
      }
    },
    update(index) {
      if (this.modelPermissions.edit) {
        console.log('listing update')
        axios
          .put(`api/admin/listings/${this.data.id}`, {
            client_id: this.client_id,
            about: this.data.about,
            description: this.data.description,
            productsServices: this.data.productsServices,
            latitude: this.data.latitude,
            longitude: this.data.longitude,
            special: this.data.special,
            links: JSON.stringify(this.data.links),
            offer: this.data.offer,
            keywords: this.data.keywords
          })
          .then(res => {
            this.clearData()
            console.log(res)
            this.changeModel(index)
          })
      } else {
        this.changeModel(index)
      }
    },
    clearData() {
      this.data = {
        id: null,
        about: '',
        description: '',
        productsServices: '',
        latitude: 0,
        longitude: 0,
        special: '',
        links: {
          facebook: '',
          instagram: '',
          youtube: ''
        },
        keywords: [],
        offer: '',
        file: null,
        image: null,
        fileLoading: false
      }
    }
  },

  watch: {
    index: function(value) {
      if (value === 5) {
        this.loading = true
        axios
          .get(`api/admin/listings/${this.client_id}`)
          .then(res => {
            if (res.data.id) {
              this.data = res.data
            }
          })
          .catch(err => {
            console.log(err)
            this.clearData()
          })
          .finally(() => (this.loading = false))
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>
